import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';

type Props = {
  label: ReactNode;
  className?: string;
};

export const LineBehind = (props: Props) => <Line className={props.className}>{props.label}</Line>;

const Line = styled.div`
  font-weight: 400;
  font-size: 2.15rem;
  margin-top: 20px;
  margin-bottom: 10px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  text-align: center;

  @media (max-width: 991px) {
    margin-top: 0;
    margin-bottom: 10px;
  }

  @media (max-width: 639px) {
    font-size: 1.7rem;
  }

  ::before {
    margin-left: -50%;
    text-align: right;
  }

  ::before,
  ::after {
    position: absolute;
    top: 51%;
    width: 49%;
    height: 1px;
    content: '\\a0';
    background-color: ${(props) => props.theme.splashPrimary4};
  }
`;
